module.exports = __webpack_public_path__ + "assets/0d5ca90b83ac94523bfccdc1f05b544e.mp3";